;(function (jQuery) {
	"use strict";

	function annualReport2025()
	{
		var fn = {
			init: function()
			{
				// Hover effects
				const image = document.querySelector('image#audit\\.psd');
				const shine1 = document.querySelector('.shine-audit');
				shine1?.addEventListener('mouseenter', () => image?.classList.add('hover-scale'));
				shine1?.addEventListener('mouseleave', () => image?.classList.remove('hover-scale'));

				const imageWage = document.querySelector('image#wage\\.psd');
				const shine2 = document.querySelector('.shine-wage');
				shine2?.addEventListener('mouseenter', () => imageWage?.classList.add('hover-scale'));
				shine2?.addEventListener('mouseleave', () => imageWage?.classList.remove('hover-scale'));

				const imageConference = document.querySelector('image#conference\\.psd');
				const shine3 = document.querySelector('.shine-conference');
				shine3?.addEventListener('mouseenter', () => imageConference?.classList.add('hover-scale'));
				shine3?.addEventListener('mouseleave', () => imageConference?.classList.remove('hover-scale'));

				const imageEdge = document.querySelector('image#edge\\.psd');
				const shine4 = document.querySelector('.shine-edge');
				shine4?.addEventListener('mouseenter', () => imageEdge?.classList.add('hover-scale'));
				shine4?.addEventListener('mouseleave', () => imageEdge?.classList.remove('hover-scale'));

				const imageAward = document.querySelector('image#award\\.psd');
				const shine5 = document.querySelector('.shine-award');
				shine5?.addEventListener('mouseenter', () => imageAward?.classList.add('hover-scale'));
				shine5?.addEventListener('mouseleave', () => imageAward?.classList.remove('hover-scale'));

				const popupOverlay = document.querySelector('.popup-overlay');
				const popups = document.querySelectorAll('.popup-content');

				const shineToPopupMap = {
					'shine-audit': '.popup-audit',
					'shine-wage': '.popup-wage',
					'shine-conference': '.popup-conference',
					'shine-edge': '.popup-edge',
					'shine-award': '.popup-award',
				};

				function showPopup(popupEl) {
					if (!popupEl || !popupOverlay) return;

					popupOverlay.classList.add('show');
					popupOverlay.style.display = 'block';

					popups.forEach(p => {
						p.classList.remove('show');
						p.style.display = 'none';
					});

					popupEl.style.display = 'block';
					requestAnimationFrame(() => {
						popupEl.classList.add('show');
					});
				}

				Object.entries(shineToPopupMap).forEach(([shineClass, popupSelector]) => {
					const shineEl = document.querySelector(`.${shineClass}`);
					const popupEl = document.querySelector(popupSelector);

					if (shineEl && popupEl) {
						shineEl.addEventListener('click', () => showPopup(popupEl));
					}
				});

				document.addEventListener('click', (e) => {
					const popupOverlay = document.querySelector('.popup-overlay');
					const visiblePopup = document.querySelector('.popup-content.show');
					if (!popupOverlay.classList.contains('show') || !visiblePopup) return;
					if (e.target.closest('.popup-content.show')) return;
					popupOverlay.classList.remove('show');
					visiblePopup.classList.remove('show');
					setTimeout(() => {
						popupOverlay.style.display = 'none';
						visiblePopup.style.display = 'none';
					}, 500);
				});
			}
		};

		fn.init();
	}

	new annualReport2025();
})(jQuery);
